import {
  BRAND_VALUE_FILTER_TYPE,
  NAVIGATION_PATH_FILTER_TYPE,
  isFilterKeyOfType,
} from "@faire/deprecated-retailer-visitor-shared/filters/filterKeys";
import { useCategoryPageFilterKeys } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/CategoryPageShareables/hooks/useCategoryPageFilterKeys";
import { useLoggedOutCategoryPageCurrentNavigationPath } from "@faire/deprecated-retailer-visitor-shared/views/category/__internal__/CategoryPageRoot/__internal__/LoggedOutCategoryPage/__internal__/Context/useLoggedOutCategoryPageCurrentNavigationPath";
import fetchCategoryPageLayoutElements from "@faire/web-api--source/endpoints/www/api/layout/category-page/post";
import { ICategoryPageLayoutRequest } from "@faire/web-api--source/indigofair/data/ICategoryPageLayoutRequest";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

export const useLoggedOutCategoryPageLayoutElementsResponse = () => {
  /**
   * we only need to send brand value filters to BE
   * as only these filters would affect meta tags
   */
  const filter_keys = useCategoryPageFilterKeys().filter(
    (filterKey) =>
      isFilterKeyOfType(filterKey, BRAND_VALUE_FILTER_TYPE) ||
      isFilterKeyOfType(filterKey, NAVIGATION_PATH_FILTER_TYPE)
  );
  const navigationPath = useLoggedOutCategoryPageCurrentNavigationPath();
  return useQuery({
    queryKey: [navigationPath, filter_keys],
    queryFn: async ({ signal }) =>
      await fetchCategoryPageLayoutElements(
        ICategoryPageLayoutRequest.build({
          navigation_path: navigationPath,
          filter_keys: filter_keys,
        }),
        undefined,
        { signal }
      ),
    staleTime: Infinity,
    placeholderData: keepPreviousData,
  });
};
